define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Registrera en ny användare",

    'incrowd_stats.num_responders': "{{num}} expertvårdspersonal",
    'incrowd_stats.num_answers': "{{num}} besvarade frågor",
    'incrowd_stats.time_to_complete': "{{num}} minuter för att genomföra en genomsnittlig undersökning",

    // INCROWD
    'incrowd.about': "Om",
    'incrowd.contact': "Kontakta oss",
    'incrowd.press': "Press",
    'incrowd.careers': "Jobb",
    'incrowd.terms': "Villkor",
    'incrowd.t_and_c': "Villkor och regler",
    'incrowd.faq': "FAQ",
    'incrowd.privacy': "Integritet",
    'incrowd.copyright': "{{year}} InCrowd Inc, Alla rättigheter reserverade",
    'incrowd.blog': "Blogg",
    'incrowd.support': "Kundtjänst",
    'incrowd.info.ios': "Visste du att läkarna i InCrowds nätverk nu kan skicka frågor direkt till sina kollegor? Testa det nu genom att använda <InCrowd iOS App>!",
    'incrowd.refer': "Gillar du våra undersökningar? <Tipsa en vän> idag för att gå med i vår gemenskap så kan ni båda tjäna 10 USD (eller motsvarande). När din kollega svarar på en undersökning, får han eller hon en bonus!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "Mikroundersökningar,",
    'getstarted.encourage.title.two': "massiv påverkan",
    'getstarted.encourage.subtitle': "Gör som tusentals andra kvalificerade medicinska professionella och påverka utvecklingen av nya produkter och patientbehandlingar genom enkla mikroundersökningar, och vi betalar dig för det!",
    'getstarted.encourage.redirect_to_solutions': "Är du inte vårdpersonal men vill lära dig mer om InCrowd?",
    'getstarted.actions.title': "Är du ett kvalificerat medicinskt proffs?",
    'getstarted.actions.subtitle': "Registrera dig idag och börja tjäna pengar på att besvara hälsovårdsfokuserade mikroundersökningar",
    'getstarted.button.continue': "Kom igång",
    'getstarted.referral': "Logga in för att tjäna pengar från undersökningar samt din hänvisningsbonus från %{{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "Vi behöver några få detaljer av dig för att lägga upp ditt konto.",
    'details.profile_details': "Profil-uppgifter",
    'details.address_information': "Address-uppgifter",
    'details.professional_info': "Yrkesinformation",
    'details.heading.finally': "…och slutligen",
    'details.how_receive_surveys': "Hur vill du kunna ta emot undersökningar?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "Grunderna",
    'professionchoice.encourage.subtitle': "Ser du inte din profession? Berätta för oss <här> för att se till att du får information när vi lägger till din profession.",
    // AUTHENTICATION INFORMATION (step 2a)
    'authentication.encourage.title': "Vem är du?",
    'authentication.encourage.subtitle': "InCrowd behöver bekräfta din identitet men vi avslöjar aldrig eller distribuerar dina personuppgifter till tredje part.",
    'authentication.actions.select_notifications': "Välj hur du vill kunna ta emot undersökningar från oss",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Var god vänta medan vi validerar dina uppgifter",
    'validation.please_answer': "Var god svara på följande frågor för att hjälpa oss att validera dina personuppgifter",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Bekräftelse",
    'confirmation.validation_success.subtitle': "Din registrering är slutförd, välkommen till InCrowd! Du kommer få en bekräftelse inom kort via e-post och/eller textmeddelande. Tack för att du anslutit dig!",
    'confirmation.validation_error.title': "Ytterligare information krävs",
    'confirmation.validation_error.subtitle': "Vi beklagar, %{userFirstName}, det uppkom ett problem med att validera dina personuppgifter.",
    'confirmation.actions_title': "Vad händer nu?",
    'confirmation.go_to_your_profile': "Gå till din profil",
    'confirmation.validation_success.actions_subtitle': "Du kommer börja ta emot våra 5-10 minuters undersökningar om ett par dagar via e-post eller textmeddelande. Inte valt att ta emot undersökningar via textmeddelande ännu? Du kan ändra dina kommunikationsinställningar när som helst från din InCrowd-profil.",
    'confirmation.validation_error.actions_subtitle': "Använd popup-chatten längst ned till höger på skärmen för att tala med en teammedlem hos InCrowd och ta itu med eventuella kvarstående frågor.",
    'confirmation.referral.info.1': "Inom %{payoutBusinessDays} affärsdagar efter du genomfört en andra enkät, <kommer> du och den person som hänvisade dig, <vardera att få %{referralBonusAmount}%{currency}> . De {%referralBonusAmount}%{currency} kommer att läggas till ditt belöningskonto. Du kan logga in på din profil närsomhelst för att uppdatera inställningar, granska dina belöningar eller få tillgång till alla öppna undersökningar som du har blivit inbjuden till.",
    'confirmation.referral.info.2': "Frågor? <Chatta med oss>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Är du kvalificerad?",
    'regftr.markets.accepting': "InCrowd Answers accepterar för närvarande:",
    'regftr.peers.title': "Delningar",
    'regftr.peers.subtitle': "Jämför dina svar med svar från andra och lär dig av deras svar.",
    'regftr.invites.title': "Inbjudningar",
    'regftr.invites.subtitle': "Få nya undersökningsinbjudningar via e-post eller i din mobil för att maximera dina inkomster.",
    'regftr.earnings.title': "Inkomster",
    'regftr.earnings.subtitle': "Hantera och spåra dina inkomster och din betalningsinformation.",
    'regftr.stats.title': "Statistik",
    'regftr.stats.subtitle': "Få tillgång till en instrumentpanel med all undersökningsinformation och dina användaruppgifter.",

    'contextual_help.sms': "Du kommer få SMS-meddelanden om öppna mikroundersökningar. Via SMS kommer du komma åt undersökningar snabbare och tjäna fler belöningar. Din information hålls privat och används endast till undersökningsinbjudningar.",
    'contextual_help.specialty': "Vänligen inkludera enbart specialområden kopplade till din NPI som du slutfört ditt medlemskap i eller medicinområden som faller direkt under ditt primära specialområde. Om du i framtiden behöver göra ändringar i dina specialområden, kontakta support@incrowdnow.com.",
    // USER
    'user(s)': "Användare |||| Användare",
    'user.login': "Logga in",
    'user.logout': "Logga ut",
    'user.register': "Registrera",
    'user.invitations': "Inbjudningar",
    'user.email': "E-postadress",
    'user.pass_word': "Lösenord",
    'user.mobile': "Mobil",
    'user.mobile.hint': "Vänligen fyll i landskod (+%{phoneCode} för %{countryName})",
    'user.title': "Titel",
    'user.title_with_example': "Titel (t.ex. Dr., Fröken, Fru, Herr)",
    'user.first_name': "Förnamn",
    'user.last_name': "Efternamn",
    'user.middle_name': "Mellannamn",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "En användare",
    'user.anonymous_admin': "Admin-användare",
    'user.dashboard': "Instrumentpanel",
    'user.profile': "Profil",
    'user.profile.picture.upload': "Ladda upp profilbild",
    'user.profile.picture.change': "Ändra",
    'user.primary_lang': "Primärt språk",
    'user.primary_lang?': "Vilket är ditt primära språk?",
    'user.survey_langs?': "Vilka språk kan du tala flytande?",
    'user.notify_email': "Meddela via e-post",
    'user.notify_mobile': "Meddela via mobilen",
    'user.contact_support': "Kontakta kundtjänst",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Vänligen <kontakta oss>.",
    'user.profession': "Yrke",
    'user.profession?': "Vilket yrke har du?",
    'user.join_now': "Gå med nu",
    'user.welcome_back': "Välkommen tillbaka!",
    'user.not_a_member?': "Ännu ej medlem?",
    'user.accept_terms': "Acceptera villkor",
    'user.accept_terms.yes': "Jag accepterar <villkor och regler>",
    'user.remember_me': "Kom ihåg mig på den här enheten",
    'user.time_zone': "Tidzon",
    'user.payment.policy': "Varje gång du uppnår 25%{currency} i belöning kommer du meddelas och få möjlighet att välja bland våra utbetalningsalternativ via din InCrowd-profil. Frågor? Nå oss via chattfönstret nedan.",
    'user.country.live_work?': "Vilket land bor och arbetar du i?",
    // FORMS
    'form.button.back': "Tillbaka",
    'form.button.next': "Nästa",
    'form.button.cancel': "Avbryt",
    'form.button.submit': "Skicka",
    'form.button.continue': "Fortsätt",
    'form.button.close': "Stäng",
    'form.button.go!': "Kör!",
    'form.button.complete!': "Slutför nu!",
    'form.button.update': "Uppdatera",
    'form.button.finish': "Slutför",
    'form.button.search': "Sök",
    'form.button.end': "Slut",
    'form.search.no_matches': "Inga matchningar hittades",
    'form.confirm_email': "Bekräfta e-postadress",
    'form.confirm_pass_word': "Bekräfta lösenord",
    'form.required_fields': "Obligatoriska fält",
    'form.nothing_selected': "Inget har valts",
    'form.confirm_field': "Bekräfta %{formFieldLabel}",
    'form.choice.n/a': "N/A",
    'form.choice.yes': "Ja",
    'form.choice.no': "Nej",
    'form.choice.blank_for_all': "Lämna tomt för att välja alla",
    'form.choices.select_all': "Välj alla",
    'form.choices.deselect_all': "Välj bort alla",
    'form.field.private': "Privat fält",

    // USER ERRORS
    'user.error.dup_email': "En annan användare har redan registrerat sig med den angivna e-postadressen. <Logga in istället?>",
    'user.error.dup_sms': "En annan användare har redan registrerat sig med det angivna mobilnumret",
  }
})
